import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { ImportantNoticeDismissalStatus, ImportantNoticeSource } from '../../model/important-notice';

@Injectable({ providedIn: 'root' })
export class ImportantNoticeService {
  private readonly endpoint: string;

  constructor(
    private readonly client: HttpClient,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    this.endpoint = `${config.apiEndpointV2}/important-notices`;
  }

  getDismissal(source: ImportantNoticeSource, noticeId: string): Observable<ImportantNoticeDismissalStatus> {
    return this.client.get<ImportantNoticeDismissalStatus>(this.dismissalUrl(source, noticeId));
  }

  dismiss(source: ImportantNoticeSource, noticeId: string): Observable<void> {
    return this.client.put<void>(this.dismissalUrl(source, noticeId), null);
  }

  private dismissalUrl(source: ImportantNoticeSource, noticeId: string): string {
    return `${this.endpoint}/${source}/${encodeURIComponent(noticeId)}/dismissal`;
  }
}
